import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import TableContainer from "../../utils/TableContainer";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import Timeformat from "../../utils/Timeformat";

const moment = require("moment");

class AlarmContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            alarms: null,
            notifications: null,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.updateAlarms = this.updateAlarms.bind(this);
        this.updateNotifications = this.updateNotifications.bind(this);

    }

    componentWillMount() {

        this.updateAlarms();
        this.updateNotifications();

    }

    updateAlarms() {

        const params = {
            'id_user': this.props.baseData.userData.id,
            'language': this.props.baseData.userData.language
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    alarms: res,
                });
            }
        }.bind(this);

        this.api.request('GetAlarms', params, callback, null);

    }

    updateNotifications() {

        const params = {
            'action': 'getAllNotifications',
        };

        const callback = function(res) {
            if (res) {
                this.setState({notifications: res});
            }
        }.bind(this);

        this.setState({
            notifications: null
        }, () => {
            this.api.request('GetNotifications', params, callback, null);
        });

    }

    activeHandle(id, oldValue, newValue) {

        if (id && oldValue !== newValue) {
            const params = {
                action: 'saveActiveValue',
                id: id,
                active: newValue,
            };

            const callback = function (res) {
                this.updateAlarms();
            }.bind(this);

            this.api.request('SaveAlarms', params, callback, null);
        }

    }

    getAlarmSettingColumns() {

        return [
            {
                key: 'description',
                nameKey: 'description',
            },
            {
                key: 'condition',
                nameKey: 'condition',
            },
            {
                key: 'type',
                nameKey: 'alarmType',
            },
            {
                key: 'machine',
                nameKey: 'machine',
            },
            {
                key: 'lastTriggered',
                nameKey: 'lastTriggered',
            },
            {
                key: 'options',
                nameKey: 'activated',
            },
        ];

    }

    getAlarmSettingRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = this.state.alarms;
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let jsonSettings = JSON.parse(rowTemp.settings);
            let lastTriggered = (rowTemp.last_triggered && parseInt(rowTemp.last_triggered) > 0) ? Timeformat.fromUnix(rowTemp.last_triggered).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rowTemp.active = parseInt(rowTemp.active);
            rowTemp.last_triggered = parseInt(rowTemp.last_triggered);

            let classesActiveButton = ['optionNotActive', (rowTemp.active === 0) ? 'optionOpacity' : ''].join(' ').trim();
            let classesNotActiveButton = ['optionActive', (rowTemp.active === 1) ? 'optionOpacity' : ''].join(' ').trim();

            rows.push({
                id: rowTemp.id,
                active: rowTemp.active,
                description: rowTemp.description,
                type: this.translate(rowTemp.type),
                lastTriggered: lastTriggered,
                machine: (jsonSettings.machine === '-ALL-') ? 'All machines' : jsonSettings.machine,
                condition: (jsonSettings.minutesInactive) ? <span><span data-i18n="inactiveSince">{this.translate('inactiveSince')}</span>: {jsonSettings.minutesInactive} <span>Min.</span></span> : <span><span>{this.translate('limit')}</span>: {jsonSettings.limit} <span>{this.translate('per10KStitches')}</span></span>,
                options: <div className="tableOptions">
                    <a className={classesActiveButton} onClick={() => this.activeHandle(rowTemp.id, rowTemp.active, 1)} title={this.translate('active')} style={{borderTopRightRadius: 0, borderBottomRightRadius: 0, marginRight: 0}}>&nbsp;</a>
                    <a className={classesNotActiveButton} onClick={() => this.activeHandle(rowTemp.id, rowTemp.active, 0)} title={this.translate('notActive')} style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}>&nbsp;</a>
                </div>,
            });
        }

        return rows;

    }

    getTriggeredAlarmColumns() {

        return [
            {
                key: 'state',
                nameKey: 'status',
            },
            {
                key: 'inserted',
                nameKey: 'triggered',
            },
            {
                key: 'machineLocations',
                nameKey: 'machineLocation',
            },
            {
                key: 'machineNames',
                nameKey: 'machineName',
            },
            {
                key: 'description',
                nameKey: 'description',
            },
            {
                key: 'type',
                nameKey: 'alarmType',
            },
            /*{
                key: 'seen',
                nameKey: 'seen',
                classes: 'text-right',
            },
            {
                key: 'confirmed',
                nameKey: 'confirmed',
                classes: 'text-right',
            },*/
        ];

    }

    getTriggeredAlarmRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = this.state.notifications;
        const sessionCreated = this.props.baseData.session.dateCreated;
        const rows = [];

        if (data) {
            for (let i = 0; i < data.length; i++) {
                let rowTemp = data[i];
                let machineInfos = rowTemp.machines;
                let machineNames = this.getMachineNames(machineInfos);
                let machineLocations = this.getMachineLocations(machineInfos);
                let state = (rowTemp.seen > sessionCreated) ? 'error' : null;
                let dateInserted = (rowTemp.date_inserted) ? Timeformat.fromUnix(rowTemp.date_inserted).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
                let dateSeen = (rowTemp.seen) ? Timeformat.fromUnix(rowTemp.seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
                let dateConfirmed = (rowTemp.date_confirmed) ? Timeformat.fromUnix(rowTemp.date_confirmed).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

                rows.push({
                    id: rowTemp.id,
                    trClasses: state,
                    state: <i>error</i>,
                    description: rowTemp.description,
                    type: this.translate(rowTemp.type),
                    machineNames: machineNames,
                    machineLocations: machineLocations,
                    inserted: dateInserted,
                    seen: dateSeen,
                    confirmed: dateConfirmed,
                });
            }
        }

        return rows;

    }

    getMachineNames(machineInfos) {

        const row = [];

        for (let machineID in machineInfos) {
            let machine = machineInfos[machineID];

            row.push(
                <span key={machineID}>{machine.name} <br /></span>
            );
        }

        return row;

    }

    getMachineLocations(machineInfos) {

        const row = [];

        for (let machineID in machineInfos) {
            let machine = machineInfos[machineID];

            row.push(
                <span key={machineID}>{machine.location} <br /></span>
            );
        }

        return row;

    }

    renderAlarms() {

        if (this.state.alarms === null) return null;
        if (!this.state.alarms) return <LoadingSplash color={'dark'}/>;

        const alarmSettingColumns = this.getAlarmSettingColumns();
        const alarmSettingRows = this.getAlarmSettingRows();

        return (
            <div className="archivArea" style={{marginRight: 0}}>
                <TableContainer
                    baseData={this.props.baseData}
                    columns={alarmSettingColumns}
                    rows={alarmSettingRows}
                    fillGaps="-"
                />
            </div>
        );

    }

    render() {

        const alarmArea = this.renderAlarms();

        const alarmTriggeredColumns = this.getTriggeredAlarmColumns();
        const alarmTriggeredRows = this.getTriggeredAlarmRows();

        return (
            <div className="alarmContainer">
                <div className="ma-bo-20 clearfix">
                    <nav>
                        <h1>{this.translate('alarmHeader1')}</h1>
                    </nav>

                    <div>
                        <p>{this.translate('alarmText1')}</p>
                    </div>

                    {alarmArea}
                </div>

                <div className="ma-bo-20 clearfix">
                    <nav>
                        <h1>{this.translate('alarmHeader2')}</h1>
                    </nav>

                    <div>
                        <p>{this.translate('alarmText2')}</p>
                    </div>

                    <div className="archivArea" style={{marginRight: 0}}>
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={alarmTriggeredColumns}
                            rows={alarmTriggeredRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('analysis')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default AlarmContainer;
